function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6531 29.24L38.6978 41.3437C38.6069 41.718 38.2486 42.0001 37.8637 42.0003L19.2681 42.0003C19.0423 42.0013 18.8194 41.9096 18.6595 41.7499L7.03883 30.1155C5.81379 28.9537 6.00604 26.5385 7.03883 25.203C7.31644 24.8916 8.01902 24.0439 8.74147 23.7091C9.46393 23.3744 11.3759 22.7852 12.7793 23.7091L16.6307 27.0041C16.8199 27.1924 17.0606 27.3205 17.3225 27.3722C17.5843 27.4239 17.8555 27.3969 18.1021 27.2946C18.3486 27.1923 18.5594 27.0193 18.7079 26.7974C18.8565 26.5754 18.9361 26.3145 18.9368 26.0473V9.53936C18.9368 8.10967 19.9018 6.69704 21.2631 6.09315C22.8553 5.38686 24.0275 5.46885 25.5825 6.11306C26.8521 6.63904 27.836 7.88817 27.8278 9.3199V18.3074C27.8262 19.0135 28.0345 19.704 28.4264 20.2911C28.8182 20.8782 29.3757 21.3353 30.028 21.6041L39.8565 25.6658C40.5351 25.946 41.0901 26.4615 41.42 27.1179C41.7499 27.7742 41.8327 28.5276 41.6531 29.24Z"
});

var SvgIcoByhand = function SvgIcoByhand(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    stroke: "white",
    strokeWidth: 3,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoByhand, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-byhand.abff75f2.svg";
export { ForwardRef as ReactComponent };